import { DropdownMenuItem } from '@/components/shadcn/dropdown-menu'
import { CellContext } from '@tanstack/react-table'
import { RowAction } from '../../types-v4'
import { SheetWithFormComponent } from '@/components/ui/SheetWithFormComponent'
import { Suspense, useState } from 'react'
import { DynamicIcon } from '@/components/icons/DynamicIcon'
import { IconCommentOutline } from '@icons/IconCommentOutline'
import { FormComponentLoading } from '../../../FormComponent'
import { QueryErrorBoundary } from '@/catalog-apps/components/QueryErrorBoundary'
import { Collaboration } from './Collaboration'

type CollaborationItemProps<T, V> = {
  action: RowAction
  info: CellContext<T, V>
}

export function CollaborationMenuItem<T, V>({ action, info }: CollaborationItemProps<T, V>) {
  const [sheetOpen, setSheetOpen] = useState(false)

  return (
    <SheetWithFormComponent
      title="Collaboration"
      description="Collaboration description goes here."
      trigger={
        <div onClick={(e) => e.stopPropagation()}>
          <DropdownMenuItem onSelect={(e) => e.preventDefault()}>
            <div className="flex items-center gap-2">
              <DynamicIcon
                iconName={action.icon || ''}
                lazyLoad={false}
                className="size-3"
                fallback={<IconCommentOutline className="size-3" />}
              />
              <span>{action.label}</span>
            </div>
          </DropdownMenuItem>
        </div>
      }
      wide
      isOpen={sheetOpen}
      onOpenChange={setSheetOpen}
    >
      <QueryErrorBoundary errorMessage="Failed to fetch channel thread details">
        <Suspense fallback={<FormComponentLoading />}>
          <Collaboration action={action} info={info} />
        </Suspense>
      </QueryErrorBoundary>
    </SheetWithFormComponent>
  )
}
